import React from "react";
import Portfolio from "../../componets/Portfolio";

export default function Section1() {
  return (
    <div className="w-full h-[30vh] xl:h-[70vh] Section1">
      <Portfolio
        bgImage={"assets/bg-image-game-development.jpg"}
        objectPosition={"object-center-center"}
        customer={false}
        altText="Game Design & Development Background Image"
      />
    </div>
  );
}
